import ErrorSharpIcon from '@mui/icons-material/ErrorSharp';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Checkbox, FormControl, FormControlLabel, TextField, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { ChangeEvent, useState } from 'react';
import { ValidationError } from 'yup';
import useStore from '~/store';
import { Message } from '../types';
import { containerInput, containerMessage, inputStyle } from './styles';
import schema from './validation';

interface Props {
  content?: Message['content'];
  author?: Message['author'];
  Component?: Message['Component'];
  handleValidateInputs: (key: 'email' | 'name', isValid: boolean) => void;
}

export const InputName = ({ handleValidateInputs }: Props) => {
  const { quote, setName, setIsSocialName } = useStore((store) => ({
    quote: store.quote,
    setName: store.SetName,
    setIsSocialName: store.setIsSocialName,
    setIsValideZipcode: store.setIsValideZipcode
  }));
  const { name, isSocialName } = quote;
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  const validateNameValue = async (value: string) => {
    try {
      await schema.validate({
        name: value
      });
      setHelperText('');
      setError(false);
      handleValidateInputs('name', true);
    } catch (err) {
      if (err instanceof ValidationError) {
        setError(true);
        handleValidateInputs('name', false);
        setHelperText(err.message);
      }
    }
  };

  const handleChangeName = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newNameValue = event.target.value;

    setName(newNameValue);
    validateNameValue(newNameValue);
  };

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsSocialName(event.target.checked);
  };

  return (
    <Box>
      <Box sx={() => containerMessage(error)}>
        <FormControl variant="outlined" sx={containerInput}>
          <TextField
            value={name}
            onChange={handleChangeName}
            error={error}
            helperText={helperText}
            variant="outlined"
            placeholder={isSocialName ? 'Informe seu nome social' : 'Informe seu nome'}
            sx={inputStyle}
            InputProps={{
              endAdornment: error && <ErrorSharpIcon color="error" />
            }}
          />
        </FormControl>
      </Box>

      <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isSocialName}
              onChange={handleCheckboxChange}
              sx={{
                color: '#fff',
                '&.Mui-checked': {
                  color: '#A547FF'
                }
              }}
            />
          }
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography variant="body2" sx={{ color: '#fff' }}>
                Tenho um nome social e desejo usá-lo
              </Typography>
              <Tooltip title="O nome social é escolhido por pessoas cujo nome civil não reflete sua identidade de gênero.">
                <InfoIcon sx={{ color: '#A547FF', fontSize: 18, cursor: 'pointer' }} />
              </Tooltip>
            </Box>
          }
          sx={{ margin: 0 }}
        />
      </Box>
    </Box>
  );
};
